/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Social_DescInputs */

const en_lg_social_desc = /** @type {(inputs: Lg_Social_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React, greet the mascot, or play Together Lights in the same room. Celebration sounds require your permission.`)
};

const id_lg_social_desc = /** @type {(inputs: Lg_Social_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim reaksi, sapa maskot, atau mainkan Pola Bersama di ruang yang sama. Suara selebrasi memerlukan izinmu.`)
};

/**
* | output |
* | --- |
* | "React, greet the mascot, or play Together Lights in the same room. Celebration sounds require your permission." |
*
* @param {Lg_Social_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_social_desc = /** @type {((inputs?: Lg_Social_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Social_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_social_desc(inputs)
	return en_lg_social_desc(inputs)
});